/* eslint-disable no-console */
import { Component, signal, Input, Inject, Output, OnInit, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescriptionComponent } from '@/app/shared/description/description.component';
import { DesyAngularModule } from 'desy-angular';
import { FormsModule } from '@angular/forms';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { NewAccessionData } from '@/app/interfaces/new-accession-data';
import { NewAdhesionService } from '@/app/services/new-adhesion.service';
import { ToastService } from '@/app/services/script/toast.service';
import normative from '@/app/enums/normative.enum';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Router } from '@angular/router';
import { SpanishDatePipe } from '../../../../../pipe/date.pipe';
export interface Info {
  icon: string;
  style?: string;
  tooltip: string;
}

interface DescriptionConfig {
  title: string;
  description: string;
  linkText: string;
  icons?: Info[];
  linkReference?: string;
  externalLink?: string;
  action?: () => void;
  subtitle?: string;
}

@Component({
  selector: 'app-step5',
  imports: [
    SpanishDatePipe,
    ConfirmDialog,
    ButtonsComponent,
    DescriptionComponent,
    DesyAngularModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './step5.component.html',
  providers: [ConfirmationService],
})
export class Step5Component implements OnInit {
  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    @Inject(NewAdhesionService) private newAdhesionService: NewAdhesionService,
    private toastService: ToastService
  ) {}

  @Input() data!: NewAccessionData;
  @Output() goStepFN = new EventEmitter<number>();

  resumenCards: DescriptionConfig[] = [];
  normativeEnum: typeof normative = normative;

  textAreaValue = signal<string>(null);

  goStepFNHandler(view: number): void {
    if (!view) return;
    this.goStepFN.emit(view);
  }

  confirmSendData() {
    this.confirmationService.confirm({
      message: 'Va a solicitar adhesión. ¿Está seguro/a de que desea continuar?',
      header: 'Confirmación',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Guardar',
      },
      accept: () => {
        this.sendData();
      },
    });
  }

  async sendData() {
    this.data.destination = JSON.parse(localStorage.getItem('userData')).roleCode;
    this.data.observation = this.textAreaValue() !== '' ? this.textAreaValue() : null;
    const response = await this.newAdhesionService.validateAdhesion(this.data);
    let expirationDate = null;
    if (response?.data?.attributes?.length) {
      response.data.attributes.forEach((e) => {
        if (e?.attributeDefinition && e?.attributeDefinition?.type === 'INPUT_DATE') {
          expirationDate = e.value;
        }
      });
    }
    if (response?.data?.id) {
      const fechaStr = '20991231';
      const params = {
        submit_data: {
          role: 'jefe_consumidor',
          requestReason: null,
          idAdhesion: response.data.id,
        },
        adhesion_data: {
          nameAdhesion: this.data.name.slice(4),
          creator: this.data.destination,
          serviceCode: this.data.service.id,
          objectSubType: response.data.objectSubType,
          destinationType: response.data.destinationType,
          protocoloCode: this.data.protocol.id,
          sourceType: response.data.sourceType,
          sourceModule: response.data.sourceModule,
          type: this.data.type,
          title: this.data.title,
          url: this.data.url,
          range: this.data.range,
          observation: this.data.observation !== '' ? this.data.observation : null,
          normativeDate: this.data.date ? this.data.date : null,
          startDate: response.data.startDate ? response.data.startDate : null,
          finishDate: response.data.validityDate ? response.data.validityDate : null,
          expirationDate: expirationDate
            ? expirationDate
            : new Date(`${fechaStr.slice(0, 4)}-${fechaStr.slice(4, 6)}-${fechaStr.slice(6, 8)}T00:00:00Z`),
          rpt: this.data.rpts.map((e) => e.jobCode),
        },
      };
      const responseSaveAdhesion = await this.newAdhesionService.createAdhesion(params);
      if (responseSaveAdhesion) {
        this.router.navigate(['/mis-adhesiones/listado/enviadas']);
      }
    }
  }

  isOlderThan50Years(date: Date | string): boolean {
    const givenDate = new Date(date);
    const today = new Date();
    const fiftyYears = new Date(today.getFullYear() + 50, today.getMonth(), today.getDate());
    return fiftyYears > givenDate;
  }

  async ngOnInit() {
    console.log(this.data);
    if (this.data) {
      this.resumenCards = [
        {
          title: this.data.protocol.protocolName,
          description: this.data.protocol.protocolDepartment,
          subtitle: this.data.protocol.protocolDescription,
          linkText: 'Modificar',
          action: () => this.goStepFNHandler(1),
        },
        {
          title: this.data.service.organismName,
          description: this.data.service.procedureName,
          linkText: 'Modificar',
          action: () => this.goStepFNHandler(2),
        },
      ];
    }
  }
}
